import { useEffect, useState } from 'react'
import { GetDocumentFolderStructureForArtNo } from '../../../Services/DataFolderService'
import { useConfig } from '../../../Providers/ConfigProvider'

const useHandleProductDocumentation = (index) => {
    const { api, dataUrl } = useConfig()
    const [isLoading, setIsLoading] = useState(false)
    const [documentFolderStructure, setDocumentFolderStructure] = useState(null)

    useEffect(() => {
        if (index) {
            handleGetDocumentFolderStructure(index)
        }
    }, [index])

    const handleGetDocumentFolderStructure = (index) => {
        setIsLoading(true)
        GetDocumentFolderStructureForArtNo(api, index).then(res => {
            setDocumentFolderStructure(res.data)
            setIsLoading(false)
        })
            .catch(e => {
                console.log(e)
            })
    }
    const handleOpenFile = (path) => {
        const fullPath = dataUrl + "/miniaturki/Indeksy/" + path
        window.open(fullPath, '_blank')
    }

    return { documentFolderStructure, isLoading, handleOpenFile }
}

export default useHandleProductDocumentation